module.exports = __webpack_public_path__ + "static/media/01_moriyama-cubic-prism.2ec8594e.jpg";